export default __webpack_public_path__ + "static/media/Izmir-Bold.88ee3989.woff";